import React, { useEffect, useMemo } from 'react';
import { decodeId } from 'utils/helpers';
import useConsentCheck from 'hooks/use-consent-check';
import useClient from 'hooks/use-client';
import ErrorCookiesSettings from '../error-cookies-settings/error-cookies-settings';
import Delay from '../delay/delay';

const ProductReviewStars = ({ productId, consentCode, errorText }) => {
  const isClient = useClient();
  const technicalConfig = useMemo(() => {
    return JSON.parse(document.querySelector('[data-technical]')?.textContent || '{}');
  }, []);

  const isConsentGranted = useConsentCheck(consentCode);

  useEffect(() => {
    if (window.yotpoWidgetsContainer?.initWidgets && isConsentGranted) {
      window.yotpoWidgetsContainer.initWidgets();
    }
  }, [productId, isConsentGranted]);

  return (
    <div>
      {isClient && !isConsentGranted && (
        <Delay waitTime={500}>
          <ErrorCookiesSettings errorText={errorText} />
        </Delay>
      )}
      {isConsentGranted && (
        <div
          className="yotpo-widget-instance"
          data-yotpo-instance-id={technicalConfig.yotpoReviewStarsWidgetId}
          data-yotpo-product-id={decodeId(productId, 'Product')}
          data-yotpo-section-id="product"
        ></div>
      )}
    </div>
  );
};

export default ProductReviewStars;
